import React from 'react';
import { TextFieldProps, TextFieldState, SelectProps } from '../forms';
import { CSSObject, styled } from '../theming';
import { IconCheckCircleFilled, IconWarningTriangleFilled } from '../Icon';
import { BabbelTheme } from '@lessonnine/design-tokens.lib/dist/json/theme';
import { fallbackTheme } from '../theming/fallbackTheme';
import { FormElementsStateProps } from './sharedTypes';
import { disabledColors } from './stylesHelper.styles';

export type HelperTextState = TextFieldState | FormElementsStateProps;

export type HelperTextProps = TextFieldProps | SelectProps;

// TODO extend this functionaly to make Helper text component
const helperStateColors = (theme: BabbelTheme, state: HelperTextState): CSSObject => {
  const currentTheme = fallbackTheme(theme);

  if (state === 'success') {
    return {
      helperTextColor: currentTheme.color.feedback.success.onSurface,
    };
  }

  if (state === 'error') {
    return {
      helperTextColor: currentTheme.color.feedback.attention.onSurface,
    };
  }

  return {};
};

export const StyledHelperTextIcon = styled.span<{
  state: HelperTextState;
  disabled?: boolean;
}>`
  color: ${({ theme, state, disabled }) => {
    if (disabled) return disabledColors(theme).additionalTextColor;
    return helperStateColors(theme, state).helperTextColor;
  }};
`;

export const HelperTextIcon = ({
  size,
  state = 'default',
  disabled,
}: Pick<HelperTextProps, 'size' | 'state' | 'color' | 'disabled'>) => {
  const iconSize = size === 'small' || size === 'default' ? 'xsmall' : 'small';

  switch (state) {
    case 'success':
      return (
        <StyledHelperTextIcon state={state} disabled={disabled}>
          <IconCheckCircleFilled size={iconSize} color={'currentColor'} />
        </StyledHelperTextIcon>
      );
    case 'error':
      return (
        <StyledHelperTextIcon state={state} disabled={disabled}>
          <IconWarningTriangleFilled size={iconSize} color={'currentColor'} />
        </StyledHelperTextIcon>
      );
    default:
      return null;
  }
};
